/**
 * @file index.tsx
 * @module app/modules/pending-delivery-orders/index
 * @description Implements the index workflow for pending delivery orders.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { lazy } from 'react';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
import PendingDeliveryOrders from './PendingDeliveryOrders';

const pendingDeliveryOrdersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Pending Delivery Orders',
    path: '/pending-delivery-orders',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={
            <>
              <PageTitle>
                Pending Delivery Orders
              </PageTitle>
              <PendingDeliveryOrders />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default index;
